"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleTens = exports.handleTeens = exports.handleOnes = exports.isSecondCharZero = exports.isFirstCharZero = void 0;
var en_1 = require("../lang/en");
function isFirstCharZero(value) {
    return +value[0] === 0;
}
exports.isFirstCharZero = isFirstCharZero;
function isSecondCharZero(value) {
    return +value[1] === 0;
}
exports.isSecondCharZero = isSecondCharZero;
/**
 * handles 0-9
 *
 * @param value the value to be translated to words
 * @returns translated value
 */
function handleOnes(value) {
    return en_1.singleDigit[+value];
}
exports.handleOnes = handleOnes;
/**
 * handles 11-19
 *
 * @param value the value to be translated to words
 * @returns translated value
 */
function handleTeens(value) {
    if (+value[0] === 1)
        return en_1.caseOne[+value.slice(-1)];
    else
        return "".concat(en_1.twoDigit[+value[0]], " ").concat(en_1.singleDigit[+value.slice(-1)]);
}
exports.handleTeens = handleTeens;
/**
 * handles all two-digit values except 11-19
 *
 * @param value the value to be translated to words
 * @returns translated value
 */
function handleTens(value) {
    if (isFirstCharZero(value))
        return "".concat(en_1.singleDigit[+value[1]]);
    if (isSecondCharZero(value))
        return "".concat(en_1.twoDigit[+value[0]]);
    return handleTeens(value);
}
exports.handleTens = handleTens;
